import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-choose-insurance-dialog",
  templateUrl: "./choose-insurance-dialog.component.html",
  styleUrls: ["./choose-insurance-dialog.component.scss"],
})
export class ChooseInsuranceDialogComponent implements OnInit {
  public needChangeInsurance = false;
  public needChangeAddress = false;
  public oldIns: string;
  public newIns: string;
  public updateAddress: boolean;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ChooseInsuranceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.oldIns = this.data.oldIns;
    this.newIns = this.data.newIns;
    this.updateAddress = this.data.updateAddress;
  }

  public validate() {
    this.dialogRef.close({
      needChangeInsurance: this.needChangeInsurance,
      needChangeAddress: this.needChangeAddress,
    });
  }

  public closeAll() {
    this.dialog.closeAll();
  }
}
